/* mx-gaveta-colecoes — MoxLand (30/08/2026)
   =========================================
   COMPLETA a gaveta "Coleções" da Busca Avançada com as edições que o
   Shopify NAO listou.

   O PROBLEMA: o Shopify corta a lista de valores de um filtro por volta de
   1.000 tags, e a loja tem 2.096. Resultado: a gaveta mostra ~380 de 1.019
   edições. Filtrando por MTG melhora (~330 de 693), mas ainda falta metade.
   Provado em campo: "Arena League 1996" e "Magic Player Rewards 2003"
   existem, tem carta, e nao aparecem.

   O CAMINHO E' VIAVEL porque o Shopify ACEITA filtrar por uma tag que ele
   mesmo nao listou — testamos com /collections/all/odisseia e funcionou.

   COMO FUNCIONA
   · le o que a gaveta JA' desenhou (isso vem do Shopify, ja' reagindo aos
     filtros ativos) e a lista completa do mx-colecoes.json
   · acrescenta SO' o que falta, clonando um <li> existente da propria
     pagina — assim classes, estilo e comportamento vem de graca, sem eu
     recriar nada (exigencia dele: "aparencia e funcionalidade iguais hoje")
   · reordena tudo em ordem alfabetica, como o tema faz

   O LIMITE, ASSUMIDO DE PROPOSITO (combinado com ele em 30/08): a injecao
   filtra SO' POR JOGO — que e' o filtro que de fato encolhe a lista. Em
   filtros de cor/tipo/raridade o script NAO injeta nada e a gaveta fica
   como esta' hoje. Motivo: so' o Shopify sabe quais colecoes sobrevivem a
   "azul + criatura + rara"; injetar as la' mostraria colecao que da' vazio.
   Cobrir isso exigiria reimplementar o filtro inteiro no navegador.

   DIALETO DA GAVETA (tirado do HTML real da loja, nao deduzido):
     <li class="item" style="display: none">
       <a href="javascript:void(0)" data-href="/collections/all/SLUG+mtg">
         <input type="checkbox" value="SLUG">
         <label>Nome</label>
       </a>
     </li>
   As tags se combinam com SINAL DE MAIS no caminho. */
(function () {
  if (window.__mxGavetaColecoes) return;
  window.__mxGavetaColecoes = true;

  var ARQ = window.__mxColecoesUrl || '';
  if (!ARQ) return;

  /* nomes da gaveta que nos interessam */
  var TITULOS = ['colecoes', 'colecao', 'collections', 'collection'];

  /* as tags de jogo, do jeito que aparecem no caminho da URL */
  var JOGOS = { 'flesh-and-blood-tcg': 'fab', fab: 'fab', mtg: 'magic', pokemon: 'pokemon', pok: 'pokemon',
                'one-piece': 'onepiece', onepiece: 'onepiece',
                op: 'onepiece' };

  var todas = null;       /* [[nome, handle, jogo], ...] */
  var conhecidas = {};    /* handle -> 1, para reconhecer a gaveta certa */

  function normal(s) {
    return String(s || '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toLowerCase().replace(/\s+/g, ' ').trim();
  }

  /* o jogo filtrado agora, lido do caminho da pagina.
     /collections/all/mtg -> magic ; /collections/all/odisseia+mtg -> magic */
  function jogoAtivo() {
    var partes = window.location.pathname.split('/').filter(Boolean);
    if (partes.length < 3) return null;
    var tags = partes.slice(2).join('+').split('+');
    for (var i = 0; i < tags.length; i++) {
      var j = JOGOS[tags[i].toLowerCase()];
      if (j) return j;
    }
    return null;
  }

  /* quais tags ja' estao no caminho — o item novo tem que carregar todas,
     senao clicar nele perderia os filtros que o cliente ja' escolheu */
  function tagsAtuais() {
    var partes = window.location.pathname.split('/').filter(Boolean);
    if (partes.length < 3) return [];
    return partes.slice(2).join('+').split('+').filter(Boolean);
  }

  /* ha' filtro que nao seja de jogo? entao NAO injetamos (ver "O LIMITE") */
  function temFiltroFino() {
    var tags = tagsAtuais();
    for (var i = 0; i < tags.length; i++) {
      if (!JOGOS[tags[i].toLowerCase()]) return true;
    }
    return !!window.location.search.replace(/^\?/, '')
      .split('&').filter(function (p) {
        return p && p.indexOf('page=') !== 0 && p.indexOf('sort_by=') !== 0
          && p.indexOf('view=') !== 0 && p.indexOf('_=') !== 0;
      }).length;
  }

  /* ESTRUTURA REAL da loja, tirada da pagina viva em 30/08 (a minha
     primeira tentativa procurava .sidebarBlock/details e NAO achava nada):
       UL.list-tags  <  DIV.widget-content  <  DIV.widget.sidebar-tags
       <  DIV.sidebar-filter  <  FORM.facets__form
     O titulo fica na caixa .widget, acima do .widget-content. */
  function acharGavetas() {
    var fora = [];
    var caixas = document.querySelectorAll(
      '.widget, .sidebarBlock, .facets__disclosure, details, .filter-group');
    Array.prototype.forEach.call(caixas, function (c) {
      var lista = c.querySelector('ul.list-tags, ul');
      if (!lista) return;
      var t = c.querySelector(
        '.widget-title, .sidebarBlock-heading, summary,'
        + ' .facets__summary, h2, h3, h4, .title');
      var titulo = t ? normal(t.textContent) : '';
      if (TITULOS.indexOf(titulo) >= 0) {
        fora.push(lista);
        return;
      }
      /* Sem titulo reconhecivel, NAO basta ter cara de gaveta: as de Cor,
         Tipos e Raridade tem a MESMA estrutura, e injetar coleção la'
         seria um estrago. A prova segura e' o CONTEUDO — os itens que ja'
         estao dentro tem que ser coleções da nossa propria lista. */
      if (titulo) return;
      var itens = lista.querySelectorAll('li input[value]');
      if (!itens.length) return;
      var acertos = 0, olhados = 0;
      Array.prototype.forEach.call(itens, function (inp) {
        if (olhados >= 5) return;
        olhados++;
        if (conhecidas[inp.getAttribute('value')]) acertos++;
      });
      /* maioria dos primeiros itens sendo coleção nossa = e' a gaveta certa */
      if (olhados && acertos > olhados / 2) fora.push(lista);
    });
    return fora;
  }

  function completar(lista) {
    if (lista.getAttribute('data-mx-completa')) return;
    if (!todas || !todas.length) return;

    var modelo = lista.querySelector('li');
    if (!modelo) return;              /* sem molde, nao invento HTML */
    var link = modelo.querySelector('a[data-href]');
    if (!link) return;                /* dialeto diferente do esperado */

    if (temFiltroFino()) {            /* deixa a gaveta como o Shopify fez */
      lista.setAttribute('data-mx-completa', 'so-shopify');
      return;
    }

    var jogo = jogoAtivo();

    /* o que a gaveta ja' tem */
    var jaTem = {};
    Array.prototype.forEach.call(lista.querySelectorAll('li'), function (li) {
      var inp = li.querySelector('input[value]');
      if (inp) jaTem[inp.getAttribute('value')] = 1;
      var lab = li.querySelector('label');
      if (lab) jaTem[normal(lab.textContent)] = 1;
    });

    var tags = tagsAtuais();
    var novos = 0;

    todas.forEach(function (c) {
      var nome = c[0], handle = c[1], jg = c[2];
      if (!nome || !handle) return;
      if (jogo && jg !== jogo) return;          /* respeita o jogo filtrado */
      if (jaTem[handle] || jaTem[normal(nome)]) return;

      var li = modelo.cloneNode(true);
      li.removeAttribute('data-mx-item');
      li.setAttribute('data-mx-item', '1');

      var a = li.querySelector('a[data-href]');
      var inp = li.querySelector('input');
      var lab = li.querySelector('label');
      if (!a || !inp || !lab) return;

      /* o caminho leva a tag nova MAIS as que ja' estavam ativas */
      var caminho = [handle].concat(tags.filter(function (t) {
        return t !== handle;
      }));
      a.setAttribute('data-href', '/collections/all/' + caminho.join('+'));
      a.setAttribute('href', 'javascript:void(0)');

      inp.setAttribute('value', handle);
      inp.checked = false;
      inp.removeAttribute('checked');
      inp.removeAttribute('disabled');
      inp.removeAttribute('id');

      lab.textContent = nome;
      lab.removeAttribute('for');

      lista.appendChild(li);
      novos++;
    });

    if (novos) {
      /* ordem alfabetica, como o tema faz — ignorando acento */
      var itens = Array.prototype.slice.call(lista.querySelectorAll('li'));
      itens.sort(function (a, b) {
        var na = normal((a.querySelector('label') || {}).textContent);
        var nb = normal((b.querySelector('label') || {}).textContent);
        return na < nb ? -1 : (na > nb ? 1 : 0);
      });
      itens.forEach(function (li) { lista.appendChild(li); });
    }

    lista.setAttribute('data-mx-completa', String(novos));
  }

  function varrer() {
    if (!todas) return;
    setTimeout(function () {
      acharGavetas().forEach(completar);
    }, 80);
  }

  function comecar() {
    fetch(ARQ).then(function (r) { return r.json(); })
      .then(function (d) {
        todas = Array.isArray(d) ? d : (d.colecoes || []);
        if (!todas.length) return;
        /* aceita tanto ["Nome", ...] quanto [["Nome","handle","jogo"], ...] */
        if (typeof todas[0] === 'string') {
          todas = todas.map(function (n) {
            return [n, normal(n).replace(/[^a-z0-9]+/g, '-')
              .replace(/^-+|-+$/g, ''), 'magic'];
          });
        }
        todas.forEach(function (c) { conhecidas[c[1]] = 1; });
        varrer();
        var obs = new MutationObserver(function () { varrer(); });
        if (document.body) {
          obs.observe(document.body, { childList: true, subtree: true });
        }
        document.addEventListener('shopify:section:load', varrer);
      }).catch(function () { /* silencio: a gaveta fica como esta' hoje */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', comecar);
  } else {
    comecar();
  }
})();


/* mx-gavetas — MoxLand (20/10/2026)
   =================================
   Completa TODAS as gavetas da sidebar com as tags que o Shopify nao
   listou.

   O PROBLEMA, o mesmo desde 30/08: o Shopify corta a lista de valores
   de um filtro por volta de 1.000 tags e a loja tem 2.096.  Medido na
   pagina viva em 20/10: Tipos 30 de 32, Raridade 22 de 24, + Filtros
   45 de 48, Card Game 3 de 4.  As que somem existem e tem produto —
   V-UNIAO tem 24 cartas, Marcador de Vida tem 32.

   DE ONDE VEM A LISTA: assets/mx-gavetas.json, publicado pelo
   gerar_gavetas.py DEPOIS de perguntar a' loja quais tags tem produto.
   Isso nao e' zelo exagerado: tag que nao existe nao da' vazio no
   Shopify, da' a LOJA INTEIRA (25.001 produtos), entao injetar uma
   dessas seria pior do que ela faltar.

   A TRAVA CONTRA ESTRAGO e' o TITULO: so' mexo numa gaveta cujo titulo
   bate com um do arquivo, e so' ponho ali as tags daquela gaveta.
   Assim a de Cor nunca recebe raridade, e a de Raridade nunca recebe
   cor — as tres tem a mesma estrutura de HTML, e foi esse o cuidado
   que a gaveta Colecoes ja' exigiu.

   O CAMINHO do item novo preserva o contexto: dentro de uma colecao
   ele aponta para aquela colecao, e soma a tag nova a's que ja' estao
   ativas com SINAL DE MAIS, que e' o dialeto da loja. */
(function () {
  if (window.__mxGavetas) return;
  window.__mxGavetas = true;

  /* o endereco sai do que a gaveta Colecoes ja' usa, trocando so' o
     nome do arquivo — assim nao preciso de snippet novo no tema.

     ⭐ 23/10: e TIRO o ?v=... que vem pendurado.  Aquele numero e' a
     versao do mx-colecoes.json, nao do meu arquivo: quando eu
     republicava as gavetas, o endereco continuava identico e o CDN
     servia a copia velha PARA SEMPRE.  Foi assim que o 'Outro Idioma'
     ficou um dia inteiro sem aparecer, e eu culpei o cache quando a
     culpa era do endereco.  Em troca ponho um numero meu que muda de
     hora em hora: atualiza rapido e nao atropela o CDN. */
  var ARQ = (window.__mxGavetasUrl
    || String(window.__mxColecoesUrl || '')
         .replace('mx-colecoes.json', 'mx-gavetas.json'));
  if (!ARQ || ARQ.indexOf('mx-gavetas.json') < 0) return;
  ARQ = ARQ.split('?')[0] + '?mx='
    + Math.floor(new Date().getTime() / 3600000);

  var gavetas = null;   /* [[titulo, [[nome, handle], ...]], ...] */

  function normal(s) {
    return String(s || '')
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .toLowerCase().replace(/\s+/g, ' ').trim();
  }

  /* ⭐ A TRAVA MAIS IMPORTANTE (medida em 20/10, na pagina viva).

     Com um filtro ATIVO o Shopify ja' faz a coisa certa sozinho: em
     /collections/all/mtg a gaveta Energia vai a ZERO e a de Cor fica;
     em /collections/all/pokemon-tcg acontece o contrario, e Tipos cai
     de 30 para 17.  Ou seja, o "somem os filtros que nao sao
     compartilhados e ficam os compartilhados" JA' FUNCIONA — ele
     consegue porque, filtrado, sao poucas tags para listar e cabem no
     teto.  O teto so' machuca na pagina SEM filtro, onde ele tem 2.096
     tags para listar e corta as menos usadas.

     Entao injetar com filtro ativo seria ESTRAGAR o que funciona: eu
     devolveria para a tela justamente as tags que o Shopify tirou de
     proposito, e o cliente clicaria num filtro que da' vazio. */
  function semFiltroAtivo() {
    var partes = window.location.pathname.split('/').filter(Boolean);
    if (partes[0] === 'collections' && partes.length > 2) return false;
    return !window.location.search.replace(/^\?/, '').split('&')
      .filter(function (p) {
        return p && p.indexOf('page=') !== 0 && p.indexOf('sort_by=') !== 0
          && p.indexOf('view=') !== 0 && p.indexOf('_=') !== 0;
      }).length;
  }

  /* /collections/arcane-rising + 'comum' -> /collections/arcane-rising/comum
     /collections/all/mtg       + 'rara'  -> /collections/all/mtg+rara */
  function caminhoCom(handle) {
    var partes = window.location.pathname.split('/').filter(Boolean);
    if (partes[0] !== 'collections') {
      return '/collections/all/' + handle;
    }
    var colecao = partes[1] || 'all';
    var tags = partes.slice(2).join('+').split('+').filter(Boolean);
    if (tags.indexOf(handle) < 0) tags.push(handle);
    return '/collections/' + colecao + '/' + tags.join('+');
  }

  /* troca so' o nome do arquivo na imagem do vizinho:
     .../files/mtg.png -> .../files/flesh-and-blood-tcg.png
     (gaveta de texto nao tem imagem, e ai' nao mexo no estilo) */
  function imagemDoVizinho(modelo, handle) {
    var a = modelo.querySelector('a');
    var estilo = a ? (a.getAttribute('style') || '') : '';
    var m = estilo.match(/url\(([^)]+)\)/);
    if (!m) return null;
    return m[1].replace(/^["']|["']$/g, '')
      .replace(/[^\/]+\.(png|jpg|jpeg|webp|svg)(\?[^)]*)?$/i,
               handle + '.png');
  }

  function oQueJaTem(ul) {
    var tem = {};
    Array.prototype.forEach.call(ul.querySelectorAll('li'), function (li) {
      var inp = li.querySelector('input[value]');
      if (inp) tem[normal(inp.getAttribute('value'))] = 1;
      var a = li.querySelector('a[data-href]');
      if (a && a.getAttribute('title')) tem[normal(a.getAttribute('title'))] = 1;
      var lab = li.querySelector('label');
      if (lab) tem[normal(lab.textContent)] = 1;
    });
    return tem;
  }

  /* ⭐ 22/10: a gaveta Pitch nasceu VAZIA — o Shopify nao desenhou
     nenhum item dela, e sem um <li> na propria gaveta eu nao tinha o
     que clonar, entao ela ficava em zero para sempre.  Quando isso
     acontece, pego o molde de outra gaveta da mesma pagina, dando
     preferencia a uma do mesmo tipo: as caixas 'filter-color'
     desenham imagem de fundo, as outras desenham texto, e clonar de
     uma para a outra traria a estrutura errada. */
  function moldeDeOutra(ul) {
    var caixa = ul.closest ? ul.closest('.widget, .sidebarBlock') : null;
    var cor = caixa && /filter-color/.test(caixa.className || '');
    var todas = document.querySelectorAll('ul.list-tags');
    var reserva = null;
    for (var i = 0; i < todas.length; i++) {
      var outra = todas[i];
      if (outra === ul) continue;
      var li = outra.querySelector('li');
      if (!li || !li.querySelector('a[data-href]')) continue;
      var c2 = outra.closest ? outra.closest('.widget, .sidebarBlock')
                             : null;
      var cor2 = c2 && /filter-color/.test(c2.className || '');
      if (cor === cor2) return li;      /* mesmo tipo: serve bem */
      if (!reserva) reserva = li;       /* guarda como ultimo recurso */
    }
    return reserva;
  }

  function completar(ul, itens) {
    if (ul.getAttribute('data-mx-gaveta')) return;
    var modelo = ul.querySelector('li') || moldeDeOutra(ul);
    if (!modelo) return;                /* sem molde, nao invento HTML */
    if (!modelo.querySelector('a[data-href]')) return;

    var tem = oQueJaTem(ul);
    var novos = 0;

    itens.forEach(function (par) {
      var nome = par[0], handle = par[1];
      if (!nome || !handle) return;
      if (tem[normal(handle)] || tem[normal(nome)]) return;

      var li = modelo.cloneNode(true);
      var a = li.querySelector('a[data-href]');
      if (!a) return;

      a.setAttribute('data-href', caminhoCom(handle));
      a.setAttribute('href', 'javascript:void(0)');
      a.setAttribute('title', nome);
      var img = imagemDoVizinho(modelo, handle);
      if (img) {
        a.setAttribute('style', 'background-image: url(' + img + ');'
          + ' background-size: cover;');
      }

      var inp = li.querySelector('input');
      if (inp) {
        inp.setAttribute('value', handle);
        inp.checked = false;
        inp.removeAttribute('checked');
        inp.removeAttribute('id');
      }
      var lab = li.querySelector('label');
      if (lab) {
        lab.textContent = nome;
        lab.removeAttribute('for');
      }

      li.setAttribute('data-mx-item', '1');
      li.style.removeProperty('display');
      ul.appendChild(li);
      tem[normal(handle)] = 1;
      novos++;
    });

    ul.setAttribute('data-mx-gaveta', String(novos));
  }

  function varrer() {
    if (!gavetas) return;
    if (!semFiltroAtivo()) return;   /* filtrado, o Shopify manda */
    setTimeout(function () {
      var caixas = document.querySelectorAll('.widget, .sidebarBlock');
      Array.prototype.forEach.call(caixas, function (c) {
        var t = c.querySelector(
          '.widget-title, .sidebar-title, h3, h4, summary');
        if (!t) return;
        var titulo = normal(t.textContent);
        for (var i = 0; i < gavetas.length; i++) {
          if (normal(gavetas[i][0]) !== titulo) continue;
          var ul = c.querySelector('ul.list-tags, ul');
          /* ⭐ o titulo e' a trava: a gaveta de Cor so' recebe cor */
          if (ul) completar(ul, gavetas[i][1]);
          return;
        }
      });
    }, 80);
  }

  function comecar() {
    fetch(ARQ).then(function (r) { return r.json(); })
      .then(function (d) {
        gavetas = Array.isArray(d) ? d : [];
        if (!gavetas.length) return;
        varrer();
        if (document.body) {
          new MutationObserver(varrer).observe(
            document.body, { childList: true, subtree: true });
        }
        document.addEventListener('shopify:section:load', varrer);
      }).catch(function () { /* silencio: a sidebar fica como hoje */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', comecar);
  } else {
    comecar();
  }
})();
